<template>
    <div class="form-group col-md-6">
        <label for="inputs_ext" class="mb-0"> {{ $t('ext') }} </label>
        <app-input 
            id="inputs_ext" 
            class="form-control" 
            type="number" 
            v-model="selected"
            :placeholder="$t('text_type_input')"
        />
    </div>
</template>

<script>
    export default {
        name: 'extAddress',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>
